import React from 'react'
import PropTypes from 'prop-types'
import ContentContainer from 'components/ContentContainer'

const TokenInfoContentContainer = ({ children }) => (
  <ContentContainer top="calc(23vh - 40px)">
    {children}
  </ContentContainer>
)

TokenInfoContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default TokenInfoContentContainer
